import Label from '__core/shared/model/label/Label';
import { LabelType } from '__core/shared/model/label/Label.enum';
import stLabelsSelectedList from './labelsSelectedList.component';
import stLabelsSelectDialog from './labelsSelectDialog.component';
import stLabelsSelect from './labelsSelect.component';
import stLabelsList from './labelsList.component';
import labelsController from './labels.controller';
import stLabelEdit from './labelEdit.component';

export default angular
  .module('st.Label', ['st.Core', 'angular-cache'])
  .factory('Label', () => Label)
  .factory('LabelType', () => LabelType)
  .component('stLabelsSelectedList', stLabelsSelectedList)
  .component('stLabelsSelectDialog', stLabelsSelectDialog)
  .component('stLabelsSelect', stLabelsSelect)
  .component('stLabelsList', stLabelsList)
  .controller('labelsController', labelsController)
  .component('stLabelEdit', stLabelEdit)
  .service('labelService', (Label, dataService) => ({
    createLabel: (doc) => dataService.createDocument(Label, doc),
    readLabel: (doc) => dataService.readDocument(Label, doc),
    updateLabel: (doc) => dataService.updateDocument(Label, doc),
    deleteLabel: (doc) => dataService.deleteDocument(Label, doc)
  }))
  .service('labelsService', ($http, $rootScope, CacheFactory, dataService, Label, LABEL) => {
    let cache;
    if (!CacheFactory.get(LABEL.CACHE.NAME)) {
      cache = CacheFactory(LABEL.CACHE.NAME, LABEL.CACHE.STORE);
    }
    const cacheKey = (params, requestName) =>
      JSON.stringify({
        idAccount: $rootScope.CurrentAccount.id,
        idOrganization: $rootScope.CurrentOrganization.id,
        type: requestName || LABEL.CACHE.NAME,
        params
      });
    return {
      clearCache: () => cache.removeAll(),
      getAvailable: (params) =>
        dataService.apiRequest(
          cache,
          cacheKey(params, 'getAvailable'),
          params?.ignoreCache === true,
          Label.build,
          $http.get,
          LABEL.API.AVAILABLE,
          { params }
        )
    };
  })
  .constant('LABEL', {
    API: {
      AVAILABLE: '/api/v1/labels/available/'
    },
    TYPES: [
      { id: 'ticket', name: 'Deal', weight: 1 },
      { id: 'contact', name: 'Contact', weight: 2 },
      { id: 'job', name: 'Task', weight: 3 },
      { id: 'note', name: 'Note', weight: 4 },
      { id: 'file', name: 'File', weight: 4 }
    ],
    CACHE: {
      NAME: 'labelsCache',
      STORE: {
        maxAge: 60 * 1000,
        deleteOnExpire: 'aggressive',
        recycleFreq: 30 * 1000,
        storageMode: 'sessionStorage'
      }
    }
  });
